module.exports = __webpack_public_path__ + "static/media/mitie-logo-charcoal.3323a49b.svg";